module.exports = __webpack_public_path__ + "img/Icone_72.94264b90.png";